import React from 'react'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import SimpleTable from '../utils/table'
import filesize from 'file-size'
import { Button, FormGroup, Checkbox } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

const UploadQueue = ({ store }) => {
  const Action = ({ upload }) => {
    return upload && upload.file &&
      [defaultConst.STATES_UPLOAD.WAITING, defaultConst.STATES_UPLOAD.UPLOADING].includes(upload.state)
      ? <Button bsStyle='danger' bsSize='xs' onClick={() => store.cancelUpload(upload)}>
        <i className='glyphicon glyphicon-remove' />&nbsp; {store.__('Cancel')}
      </Button>
      : null
  }
  if (!store.hasRight(linkConst.LINK_FILMS) || !store.loggedUser) {
    return store.router.goTo(store.views.login, {}, store)
  }

  try {
    const queueCount = store.queue && store.queue.length
    const progress = store.progress && store.progress > 0 && (
      <div>
        {store.progress}%&nbsp;
        <i className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />
      </div>
    )

    const failedUploads = queueCount > 0 && store.queue.filter(
      i => store.isFileMissing(i) ||
        [defaultConst.STATES_UPLOAD.CANCELLED, defaultConst.STATES_UPLOAD.FAILED].includes(i.state)
    )

    const table = store.queue && store.queue.length
      ? <SimpleTable
        renderers={[
          (row) => store.isCurrUpload(row) ? progress : null,
          (row) => row.id,
          (row) => store.isFileMissing(row) ? <span style={{ color: 'red' }}>{store.__('file is missing')}</span> : row.state,
          (row) => <a href='javascript:void(0)' onClick={() => {
            store.assetTabEvent('basic', 2)
            store.assetTabEvent('flyprivate', 1)
            store.goTo('entity_detail', { entityname: 'films', id: row.video_id })
          }}><i className='glyphicon glyphicon-share-alt' />&nbsp;{row.slug}</a>,
          (row) => row.file_type,
          (row) => row.original_filename,
          (row) => filesize(row.final_length).human('si'),
          (row) => <Action upload={row} />
        ]}
        labels={['', 'id', 'status', 'slug', 'type', 'filename', 'size']}
        data={store.queue} />
      : <div><br />{store.__('- EMPTY -')}</div>

    return (
      <section>
        <Helmet title={store.__(linkConst.LINK_UPLOADS_TITLE)} />
        <h2>
          {store.__(linkConst.LINK_UPLOADS_TITLE)}&nbsp;
          <span className='badge'>{store.activeUploads}/{queueCount}</span>&nbsp;
          {<small><span className='text-danger'>
            {store.uploadStopped && store.activeUploads > 0 &&
            store.__('Stopped!')}</span> &nbsp;
          </small>}
          {store.activeUploads > 0 && !store.uploadStopped &&
            <Button bsStyle='info' onClick={() => store.stopQueueAction()}>
              <i className='glyphicon glyphicon-stop' />&nbsp; {store.__('Stop queue')}
            </Button>}
          {store.activeUploads > 0 && store.uploadStopped &&
            <Button bsStyle='success' onClick={store.resumeQueueAction}>
              <i className='glyphicon glyphicon-play' />&nbsp; {store.__('Resume queue')}
            </Button>}
        </h2>
        {<div>
          <FormGroup>
            <Checkbox inline checked={store.uploadEnc} style={{ marginRight: '1em' }}
              onClick={() => store.updateUploadEnc()}>
              {store.__('After uploading, send the file to the "encoding" queue')}</Checkbox>
            <Checkbox inline checked={store.uploadRes}
              onClick={() => store.updateUploadRes()}>
              {store.__('In case of error, restore the uploaded file "automatically"')}</Checkbox>
          </FormGroup>
        </div>}
        {store.activeUploads > 0 && store.uploadStopped && <div className='alert alert-danger'>
          <strong>{store.uploadStopped.length > 0 ? store.__('Error:') : store.__('Stopped:')}</strong> &nbsp;
          {store.uploadStopped && store.uploadStopped.length > 0
            ? store.__('The upload queue stopped because of error').concat(': ') + store.uploadStopped + '.'
            : store.__('The upload queue stopped.')
          } &nbsp;
          {store.uploadRes && store.uploadStopped.length > 0
            ? store.__('The queue restarts "automatically" in less than ') +
          ` ${defaultConst.UPLOAD_TIMEOUT_MIN} min.`
            : store.__('Click the "Resume" button to continue.')}
        </div>}
        <p>
          {table} <br />
        </p>
        {failedUploads && failedUploads.length > 0 &&
        <div className='alert alert-info'><strong>{store.__('Notice:')}</strong> &nbsp;
          {store.__('To "update/delete" canceled, missing or incorrect uploads, open the Uploads tab in the film record.')}
        </div>}
        <div className='alert alert-warning'><strong>{store.__('Warning:')}</strong> &nbsp;
          {store.__('Please use only one browser window/tab when uploading.')}
        </div>
      </section>
    )
  } catch (e) {
    console.error(e)
    return <div className='alert alert-danger'>{e.message || e}</div>
  }
}

export default inject('store')(observer(UploadQueue))
